module.exports = __webpack_public_path__ + "static/media/cycle.cdca4a73.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/cycle.svg
// module id = 454
// module chunks = 0